module.exports = __webpack_public_path__ + "img/img-classify9.12f5abdc.png";